export const POLICY_TYPES = [
  { value: 'health', label: '健康险（重疾）' },
  { value: 'cancer', label: '防癌险' },
  { value: 'medical', label: '医疗险' },
  { value: 'whole_life', label: '增额终身寿险' },
  { value: 'annuity', label: '年金险' },
  { value: 'life', label: '定期/终身寿险' },
  { value: 'accident', label: '意外险' },
]

export const POLICY_TYPE_THEMES = {
  health: 'red', cancer: 'red', medical: 'gray', whole_life: 'green',
  annuity: 'purple', life: 'blue', accident: 'orange',
}

export const getPolicyTypeTheme = (type) => POLICY_TYPE_THEMES[type] || 'gray'

export const TOP_COMPANIES = [
  '中宏保险', '中国人寿', '平安人寿', '太平洋人寿', '泰康人寿', '新华保险', '太平人寿',
  '中邮人寿', '人保寿险', '阳光人寿', '友邦人寿', '工银安盛人寿', '建信人寿',
  '农银人寿', '招商信诺人寿', '中意人寿', '中美联泰大都会人寿', '富德生命人寿',
  '中信保诚人寿', '光大永明人寿',
]

export const DEFAULT_GOALS = { health: 1000000, life: 1000000, retirement: 1000000, education: 1000000 }

export const DEFAULT_ADJUSTMENTS = {
  health: { excludedIds: [], customItems: [] },
  life: { excludedIds: [], customItems: [] },
  retirement: { excludedIds: [], customItems: [] },
  education: { excludedIds: [], customItems: [] },
}

export const newPolicy = () => ({
  id: '', company: '中宏保险', type: 'health', productName: '', applicant: '', insuredPerson: '',
  deathBenefitStatus: 'unknown', beneficiary: '', beneficiaryReminderPaused: false, effectiveDate: '', paymentTerm: 20, guaranteePeriod: '终身', annualPremium: 0,
  coverage: 0, shareCoverage: false, shareWithId: '', cvType: 'cv18', cv18: 0, cv60: 0,
  annuityFunc: 'retirement', estimatedTotal: 0, firstReceiveDate: '', severeCoverage: 0,
  mediumCoverage: 0, mildCoverage: 0, multiplePayouts: false, riders: [], note: '',
  lastPaidYear: null, statusOverride: 'auto', statusOverridePolicyYear: null,
})

export const createPolicyDraft = (policies = [], selectedPerson = 'all') => {
  const recent = selectedPerson === 'all'
    ? policies[0]
    : policies.find((policy) => [policy.applicant, policy.insuredPerson].includes(selectedPerson))
  return {
    ...newPolicy(),
    applicant: recent?.applicant || '',
    insuredPerson: recent?.insuredPerson || '',
  }
}

export const finalizePolicyDraft = (draft, { isNew = false } = {}) => {
  const output = JSON.parse(JSON.stringify(draft))
  if (isNew) output.lastPaidYear = Number(String(output.effectiveDate || '').slice(0, 4)) || null
  if (output.type === 'whole_life') {
    if (output.cvType === 'cv60') output.cv18 = 0
    else output.cv60 = 0
  }
  return output
}

export const newRider = () => ({
  type: '医疗险', name: '', guaranteePeriod: '终身', premium: 0, coverage: 0,
  shareCoverage: false, shareWithId: '',
})
